/* import __COLOCATED_TEMPLATE__ from './mcp-server-name.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type IntlService from 'embercom/services/intl';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';

interface Args {
  mcpServerId: string;
}

interface Signature {
  Args: Args;
  Element: Element;
}

export default class McpServerName extends Component<Signature> {
  @service declare store: Store;
  @service declare intl: IntlService;

  get mcpServer(): McpServer | null {
    if (!this.args.mcpServerId || !this.store) {
      return null;
    }
    return this.store.peekRecord('workflow-connector/mcp-server', this.args.mcpServerId);
  }

  get serverName(): string {
    return (
      this.mcpServer?.name || this.intl.t('workflow-connector.actions.mcp-actions.unknown-server')
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpServerName': typeof McpServerName;
    'workflow-connector/mcp-server-name': typeof McpServerName;
  }
}
